import { Image } from 'expo-image';

import { oauth_google } from '@/assets/images';
import { Button, ButtonText } from '@/components/ui/button';

interface GoogleSignInButtonProps {
  onPress: () => void;
}

/** The "Continue with Google" button, drawn the same on every screen that offers it. */
export function GoogleSignInButton({ onPress }: GoogleSignInButtonProps) {
  return (
    <Button
      testID="login-google-button"
      onPress={onPress}
      variant="outline"
      className="flex-row items-center gap-x-3">
      <Image source={oauth_google} style={{ width: 20, height: 20 }} contentFit="contain" />
      <ButtonText>Continue with Google</ButtonText>
    </Button>
  );
}
